import { mutation } from 'services/graphql';
import { gql } from '@apollo/client';

export const revokeUserAccessOnSurfaceMutation = gql`
  mutation revokeUserAccessOnSurface($input: RevokeUserAccessOnSurfaceInput!) {
    revokeUserAccessOnSurface(input: $input) {
      error
      success
    }
  }
`;

export default mutation(revokeUserAccessOnSurfaceMutation);
